import React from 'react'

const RoundedRec = ({style}) => {

  return (
   
    <svg
      width="369"
      height="244"
      viewBox="0 0 369 244"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
   
    >
      <path
        d="M1.3536 129.2C3.06522 75.9866 42.4599 31.5501 95.0848 23.4732L232.313 2.4114C296.588 -7.45366 356.742 36.509 366.861 100.745C377.822 170.328 325.81 233.968 255.438 237.078L116.739 243.208C52.4185 246.05 -0.716197 193.55 1.3536 129.2Z"
        stroke="#EF4EA7"
      />
    </svg>
    
  )
}

export default RoundedRec